import $ from 'jquery';
import '../../../node_modules/bootstrap-sass/assets/javascripts/bootstrap/affix';
import * as helpers from './helpers';
import {els, constants, breakpoints} from './variables';

let stickyCart;

function initShoppingCart() {

	stickyCart = $('.sidebar-cart .cart-container');

	/**
	 * Bootstrap Sticky Nav
	 * @link http://getbootstrap.com/javascript/#affix
	 */
	if(stickyCart.length > 0) {
		stickyCart.affix({
			offset: {
				top: function() {
					return (this.top = stickyCart.offset().top - els.header.height());
				},
				bottom: function() {
					return (this.bottom = $('.site-footer').outerHeight(true));
				}
			}
		});

		stickyCart.on('affixed.bs.affix', function() {
			if(els.viewport.width() >= breakpoints.md) {
				$(this).css({
					top: els.header.height() + constants.scrollTopOffset
				});
			}
		});
	}
}

function handleCartOnResize(e) {
	if(stickyCart.length > 0) {
		if(els.viewport.width() >= breakpoints.md) {
			$("body").css({
				paddingBottom: 0
			});
		} else {
			$("body").css({
				paddingBottom: stickyCart.outerHeight()
			});
		}
	}
}

document.addEventListener('DOMContentLoaded', initShoppingCart);
window.addEventListener('resize', helpers.debounce(handleCartOnResize));
